import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage, defineMessages } from 'react-intl';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';

import { TopPlayers } from '#src/components/scoutingCenter/gameCenter/TopPlayers/index.tsx';

import type { TopPerformers_anyGameInterface } from './__generated__/index.graphql.ts';

const messages = defineMessages({
  topPerformers: {
    defaultMessage: 'Top Performers',
  },
});

type Props = {
  anyGame: TopPerformers_anyGameInterface;
  onPlayerDetailsClick?: (playerSlug: string) => void;
};

export const TopPerformers = ({ anyGame, onPlayerDetailsClick }: Props) => {
  const topPerformers = [...anyGame.anyPlayers]
    .sort(
      (a, b) =>
        (b.playerGameScore?.score ?? 0) - (a.playerGameScore?.score ?? 0)
    )
    .slice(0, 5);

  return (
    <Vertical gap={3}>
      <TopPlayers
        title={<FormattedMessage {...messages.topPerformers} />}
        anyGame={anyGame}
        players={topPerformers}
        onPlayerDetailsClick={onPlayerDetailsClick}
      />
    </Vertical>
  );
};

TopPerformers.fragments = {
  anyGameInterface: gql`
    fragment TopPerformers_anyGameInterface on AnyGameInterface {
      id
      anyPlayers {
        slug
        playerGameScore(gameId: $gameIdWithoutPrefix) {
          id
          score
        }
      }
      ...TopPlayers_AnyGameInterface
    }
    ${TopPlayers.fragments.AnyGameInterface}
  ` as TypedDocumentNode<TopPerformers_anyGameInterface>,
};
